import TFormSelect from './FormSelect.vue'

export const FormSelect = TFormSelect
